import type { Day } from "@/api-types";

export const parseTimeStringToNumber = (timeString: string | number) => {
  if (typeof timeString === "number") {
    return timeString;
  }

  // Remove the colon from the string
  const timeWithoutColon = timeString.replace(":", "");

  return parseInt(timeWithoutColon, 10);
};

export const daysOptions: { label: string; value: Day }[] = [
  { label: "Monday", value: "MON" },
  { label: "Tuesday", value: "TUE" },
  { label: "Wednesday", value: "WED" },
  { label: "Thursday", value: "THU" },
  { label: "Friday", value: "FRI" },
  { label: "Saturday", value: "SAT" },
  { label: "Sunday", value: "SUN" },
];

export const convertTimeToString = (time: number): string => {
  // Ensure the input is a 4-digit number
  const paddedTime = time.toString().padStart(4, "0");

  // Extract the hours and minutes from the number
  const hours = paddedTime.slice(0, 2);
  const minutes = paddedTime.slice(2, 4);

  // Return the formatted time
  return `${hours}:${minutes}`;
};

export const specialtyOptions = [
  { value: "aggression", label: "Aggression" },
  { value: "separation_anxiety", label: "Separation Anxiety" },
  { value: "reactivity", label: "Reactivity" },
  { value: "puppy_training", label: "Puppy Training" },
  { value: "agility", label: "Agility" },
  { value: "obedience", label: "Obedience Training" },
  { value: "socialization", label: "Socialization" },
  { value: "scent_work", label: "Scent Work/Detection" },
  { value: "dog_child", label: "Dog-Child Relationship" },
  { value: "rescues", label: "Rescues" },
  { value: "overexcitement", label: "Overexcitement" },
];

export const specialtyOptionsMap = Object.fromEntries(
  specialtyOptions.map((option) => [option.value, option.label]),
);

export const getSpecialtyLabel = (specialty: string) =>
  specialtyOptionsMap[specialty] ?? specialty;
